import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { config } from '@/helpers/Environment';
import { isTrueish } from '@/helpers/StringHelpers';
import FormInput2 from '@/components/forms/FormInput2.vue';
import { isCurrentMember } from '@/state/Membership';
@Component({
    name: 'AdmitFields',
    components: {
        FormInput2,
    },
})
export default class default_1 extends Vue {
    @Prop({
        default: () => ({
            first: '',
            last: '',
            email: '',
        }),
    })
    value;
    @Prop({ required: true })
    emailRequired;
    /** If these fields refer to the primary member, we add autocomplete attributes, otherwise we use `autocomplete="off"` (as per WCAG 1.3.5). */
    @Prop({ default: false })
    isPrimary;
    initialDetails = null;
    created() {
        this.initialDetails = { ...this.value };
    }
    get input() {
        return { ...this.value };
    }
    @Emit('input')
    emit() {
        return this.input;
    }
    get showEmailInput() {
        return this.emailRequired !== 'no';
    }
    get isEmailRequired() {
        return this.emailRequired === 'yes';
    }
    get disableEditing() {
        return isCurrentMember() && isTrueish(config.prevent_membership_updates || 'false');
    }
    get firstNameAutocomplete() {
        return this.isPrimary ? 'given-name' : 'off';
    }
    get lastNameAutocomplete() {
        return this.isPrimary ? 'family-name' : 'off';
    }
    get emailAutocomplete() {
        return this.isPrimary ? 'email' : 'off';
    }
}
